import React, { useEffect, useState } from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import convertUtcToLocal from '@utilities/ConvertTimezone';
import { APP_LABELS, OVERVIEW_CAMP_LABLES } from '@config/app-config';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';

import { getOvernightCampDataOverview } from '@redux/overnight-camp-data-overview/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';

import tabDesign from '@static/images/annualReports/tabDesign.svg';
import tabComponent from '@static/images/annualReports/tabComponent.svg';

const OverviewTab = props => {
  const { setLoader, LoginUserData, ApiParameterData, handleGetOverviewData } =
    props;

  const [errorPopup, setErrorPopup] = useState(false);
  const [overviewData, setOverviewData] = useState([]);

  const role = get(LoginUserData, 'user.role[0]');

  const staffSubIds = ['totalStaff-tab', 'wages-tab'];
  const ParticipationsAndEnrollmentSubIds = [
    'enrollmentAndOccupancy-tab',
    'Participants-tab'
  ];
  const FinancialsSubIds = ['revenue-tab', 'expenses-tab'];
  const programAndPropertySubIds = ['programAndProperty-tab'];

  useEffect(() => {
    setLoader(true);
    handleGetOverviewData(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      ApiParameterData?.year
    ).then(res => {
      if (res?.status === 200) {
        setOverviewData(res?.data?.sections);
        setLoader(false);
      } else {
        setLoader(false);
        setErrorPopup(true);
      }
    });
  }, []);

  const redirect = (id, subId, branchId) => {
    document.getElementById(id).click();
    if (branchId) {
      sessionStorage.setItem('branchSelected', branchId);
    }
    setTimeout(() => {
      if (subId) document.getElementById(subId).click();
    }, 500);
  };

  const getStatus = status => {
    if (status?.toUpperCase() === APP_LABELS.STATUS_YETTOBEGIN) {
      return (
        <td className="ymca-redLine ">{APP_LABELS.STATUS_YET_TO_BEGIN}</td>
      );
    }
    if (status?.toUpperCase() === APP_LABELS.STATUS_INPROGRESS) {
      return (
        <td className="ymca-yellowLine">
          <img src={tabDesign} alt="" className="img-fluid ymca-pattren" />
          {APP_LABELS.STATUS_IN_PROGRESS}
        </td>
      );
    }
    if (status?.toUpperCase() === APP_LABELS.STATUS_COMPLETED) {
      return (
        <td className="ymca-greenLine">
          <img src={tabComponent} alt="" className="img-fluid ymca-pattren" />
          {'Completed'}
        </td>
      );
    }
    if (status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED) {
      return (
        <td className="ymca-greenLine">
          <img src={tabComponent} alt="" className="img-fluid ymca-pattren" />
          {'Submitted'}
        </td>
      );
    }
    return <td className="ymca-redLine">{APP_LABELS.STATUS_YET_TO_BEGIN}</td>;
  };

  const setAction = status => {
    if (role === APP_LABELS.YUSA_DATA_VIEWER) {
      return 'View';
    }
    if (status?.toUpperCase() === APP_LABELS.STATUS_YETTOBEGIN) return 'Start';
    if (status?.toUpperCase() === APP_LABELS.STATUS_COMPLETED) return 'Edit';
    if (status?.toUpperCase() === APP_LABELS.STATUS_INPROGRESS) return 'Edit';
    if (status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED) return 'View';
  };

  const getActions = (status, tabIdORbranchfunc, sectionName) => {
    return (
      <button
        type="button"
        className="btn btn-transparent ymca-cyanLine custom-align ymca-word-break "
        onClick={() => redirect(tabIdORbranchfunc, sectionName)}
      >
        <span>{setAction(status)}</span>
      </button>
    );
  };

  const renderSectionslist = (name, tabId) => {
    if (overviewData && overviewData.length > 1) {
      const list = overviewData?.filter(res => res.sectionName === name);
      const sectionData = list ? list[0]?.items : [];
      return sectionData?.map(element => (
        <>
          <tr>
            <td className="ymca-leftSpacer notranslate">{element?.name}</td>
            {getStatus(element?.status)}
            <td
              className={`updated-by-data notranslate ${
                !element?.lastUpdatedBy && 'text-center'
              }`}
            >
              {element?.lastUpdatedBy || '----'}
            </td>
            <td
              className={`notranslate ${
                !element?.lastUpdatedOn && 'text-center'
              }`}
            >
              {convertUtcToLocal(element?.lastUpdatedOn)}
            </td>
            <td className="ymca-cyanLine ymca-word-break">
              {getActions(element?.status, tabId, element?.name)}
            </td>
          </tr>
        </>
      ));
    }
    return '';
  };

  return (
    <div className="ymca-completeBox ymca-overDraftView">
      <div className="ymca-tableResponsive">
        <table className="table ymca-table table-striped">
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>Status</th>
              <th>Last Updated By</th>
              <th>Last Updated On</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="ymca-rowLine">01 Staff</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            {renderSectionslist(
              OVERVIEW_CAMP_LABLES.STAFF,
              'v-pills-Staff-tab',
              staffSubIds
            )}
            <tr>
              <td className="ymca-rowLine">02 Participations and Enrollment</td>
            </tr>
            {renderSectionslist(
              OVERVIEW_CAMP_LABLES.PARTICIPATIONS_AND_ENROLLMENT,
              'v-pills-participationsAndEnrollment-tab',
              ParticipationsAndEnrollmentSubIds
            )}
            <tr>
              <td className="ymca-rowLine">03 Financials</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            {renderSectionslist(
              OVERVIEW_CAMP_LABLES.FINANCIALS,
              'v-pills-financials-tab',
              FinancialsSubIds
            )}
            <tr>
              <td className="ymca-rowLine">04 Program & Property</td>
            </tr>
            {renderSectionslist(
              OVERVIEW_CAMP_LABLES.PROGRAM_AND_PROPERTY,
              'v-pills-programAndProperty-tab',
              programAndPropertySubIds
            )}
            <tr>
              <td className="ymca-rowLine">05 Review & Submit</td>
            </tr>
            {renderSectionslist(
              APP_LABELS.REVIEW_AND_SUBMIT,
              'v-pills-ReviewSubmit-tab'
            )}
          </tbody>
        </table>
      </div>
      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={APP_LABELS.COMMON_ERROR_MESSAGE}
        showErrorPopup={errorPopup}
      />
    </div>
  );
};

OverviewTab.propTypes = {
  setLoader: PropTypes.func.isRequired,
  handleGetOverviewData: PropTypes.func.isRequired,

  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleGetOverviewData: getOvernightCampDataOverview
};

const mapStateToProps = state => ({
  ApiParameterData: ApiParaSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OverviewTab));
